'use strict';

// Localisations
// ============
module.exports = {
  en: {
    tandctitle: 'Terms & Conditions',
    privacytitle: 'Privacy',
    usefuldocs: 'Useful Documents'
  },
  es: {
    tandctitle: 'Terms & Conditions',
    privacytitle: 'Privacy'
  },
  fr: {

  },
  de: {

  }
};



// WEBPACK FOOTER //
// ./client/app/terms/terms.localisations.js